import { ApiBase } from '@/api/api'
import { makeDeleteRequest } from '@/api/fetchCalls'

export type DeleteMeasureProps = {
  formId: string
  questionId: string
  clientId: string
  measureId: string
}
export const deleteMeasure = async ({
  formId,
  questionId,
  clientId,
  measureId,
}: DeleteMeasureProps): Promise<void> => {
  return makeDeleteRequest(
    ApiBase +
      `/forms/${formId}/measures/customers/${clientId}/questions/${questionId}/measure_answers/${measureId}`
  )
}
